<template>
  <div class="tab">
    <div class="tab-menu">
      <div
        v-for="(t, index) in tabs"
        :key="index"
        class="tab-item"
        :class="styleSelected(t)"
        @click="select(t)">
        {{ $l[t] }}
      </div>
    </div>

    <component class="tab-content" :is="selected"/>
    <button-find-point />
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'
import Quiz from '@/components/Map/Quiz'
import Google from '@/components/Map/Google'
import ButtonFindPoint from '@/components/Map/ButtonFindPoint'

export default {
  mixins: [ MixinLocale ],
  components: {
    mapQuiz: Quiz,
    mapCurrent: Google,
    ButtonFindPoint
  },

  data () {
    return {
      tabs: [
        'mapQuiz',
        'mapCurrent'
      ],
      selected: 'mapQuiz'
    }
  },

  methods: {
    select: function (tab) {
      this.selected = tab
    },

    styleSelected: function (tab) {
      if (this.selected === tab) {
        return { 'tab-selected': true }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {
  display: flex;
  flex-direction: column;

  &-menu {
    display: flex;
  }

  &-item {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    height: $ph-tab-map;
    &:hover {
      cursor: pointer;
    }
  }

  &-selected {
    color: #3498db;
    border-bottom: solid 2px #3498db;
  }

  &-content {
    width: 100vw;
    height: $ph-tab-content;
  }
}


</style>
